import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useNavigate, useParams } from 'libs/router'
import { FieldValues, UseFormSetError } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { queryKeys } from 'config/queryKeys'
import { setApiFieldErrors } from 'utils/formErrors'

export const useEditUserMutation = (setError: UseFormSetError<FieldValues>) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const { mutate: editUserMutation, isPending: isEditUserLoading } = useMutation({
		mutationFn: (data) => {
			// TODO: change to apiRoutes
			return axiosPrivate.patch(`/accounts/${params.id}/`, data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.users.all })

			useToast({
				type: 'success',
				message: t('User data updated')
			})()

			// TODO: change to routes
			navigate('/users')
		},
		onError: (err: any) => {
			const status = err?.response?.status

			if (status === 400) {
				setApiFieldErrors(setError, err.response.data)
			}

			useToast({
				type: 'error',
				message: (status === 403 && err.response.data?.detail) || t('Something went wrong')
			})()
		}
	})

	return {
		editUserMutation,
		isEditUserLoading
	}
}
